<!--公告及新闻稿-->
<template>
  <div>
    <transition name="moveing">
      <navgate-other ref="topTitle" v-show="isShowTopTitle"></navgate-other>
    </transition>
    
    <main class="index_main_content" ref="parentDiv">
      <div class="index_main_body other" ref="topDiv">
        <div class="zcgy_img"><img src="../../../assets/img/investor/touzizhe-banner.jpg"><div class="mask_bg"></div></div>
        <div class="zcgy_word">
          <div class="zcgy_ch">投资者关系</div>
          <div class="zcgy_en">Investor Relations</div>
        </div>
      </div>
      <!--二级导航定格-->
      <div class="second_nav_top" v-show="lockSecondTop" >
        <div class="second_nav_list">
          <div :class="{active_d:(selectedSecond == '公告及新闻稿')}" @click="clickSecondHandler('公告及新闻稿')">公告及新闻稿</div>
          <div :class="{active_d:(selectedSecond == '财务报告')}" @click="clickSecondHandler('财务报告')">财务报告</div>
          <div :class="{active_d:(selectedSecond == '董事会')}" @click="clickSecondHandler('董事会')">董事会</div>
          <div :class="{active_d:(selectedSecond == '电话会议')}" @click="clickSecondHandler('电话会议')">电话会议</div>
          <div :class="{active_d:(selectedSecond == '分析师')}" @click="clickSecondHandler('分析师')">分析师</div>
          <div :class="{active_d:(selectedSecond == '企业管治文件')}" @click="clickSecondHandler('企业管治文件')">企业管治文件</div>
          <div :class="{active_d:(selectedSecond == '联系我们')}" @click="clickSecondHandler('联系我们')">联系我们</div>
          <div :class="{active_d:(selectedSecond == '常见问题')}" @click="clickSecondHandler('常见问题')">常见问题</div>
          <div :class="{active_d:(selectedSecond == 'Investor Relations')}" @click="clickSecondHandler('Investor Relations')">Investor Relations</div>
        </div>
      </div>
      <!--二级导航-->
      <div class="second_nav" ref="secondNav">
        <div class="second_nav_list">
          <div :class="{active_d:(selectedSecond == '公告及新闻稿')}" @click="clickSecondHandler('公告及新闻稿')">公告及新闻稿</div>
          <div :class="{active_d:(selectedSecond == '财务报告')}" @click="clickSecondHandler('财务报告')">财务报告</div>
          <div :class="{active_d:(selectedSecond == '董事会')}" @click="clickSecondHandler('董事会')">董事会</div>
          <div :class="{active_d:(selectedSecond == '电话会议')}" @click="clickSecondHandler('电话会议')">电话会议</div>
          <div :class="{active_d:(selectedSecond == '分析师')}" @click="clickSecondHandler('分析师')">分析师</div>
          <div :class="{active_d:(selectedSecond == '企业管治文件')}" @click="clickSecondHandler('企业管治文件')">企业管治文件</div>
          <div :class="{active_d:(selectedSecond == '联系我们')}" @click="clickSecondHandler('联系我们')">联系我们</div>
          <div :class="{active_d:(selectedSecond == '常见问题')}" @click="clickSecondHandler('常见问题')">常见问题</div>
          <div :class="{active_d:(selectedSecond == 'Investor Relations')}" @click="clickSecondHandler('Investor Relations')">Investor Relations</div>
        </div>
      </div>
      <!--内容-->
      <investorReport v-show="selectedSecond == '公告及新闻稿'" :conditionNewsList="conditionNewsList"></investorReport>
      <investorCourt v-show="selectedSecond == '董事会'" ></investorCourt>
      <investorTelMeeting v-show="selectedSecond == '电话会议'" :telMeetingList="telMeetingList"></investorTelMeeting>
      <investorFinReport v-show="selectedSecond == '财务报告'" :finYearsReportList="finYearsReportList"></investorFinReport>
      <investorAnalyst v-show="selectedSecond == '分析师'"></investorAnalyst>
      <investorBusinessFile v-show="selectedSecond == '企业管治文件'" :businessFileList="businessFileList"></investorBusinessFile>
      <investorContactUs v-show="selectedSecond == '联系我们'"></investorContactUs>
      <investorQuestions v-show="selectedSecond == '常见问题'"></investorQuestions>
      <!--内容-->
      <!-- <div class="content_width_box">
        <div class="content_title">
          <div class="title_left_h2">公告及新闻稿</div>
          <div class="title_right_tab">
            <div class="tab1">公告</div>
            <div class="tab2">新闻稿</div>
          </div>
        </div>
        <div class="select_box">
          <input placeholder="下拉框选年度">
        </div>
        <YearsTitleListView :messageList="conditionNewsList.list" :perPage="perPage" detailRouter="invstorDetail"></YearsTitleListView>
      </div> -->

    </main>
    <footer-build @gotoBody="gotoBody"></footer-build>
    
    
  </div>
</template>
<script>

import YearsTitleListView from '../titleNews/YearsTitleListView'
import investorReport from './investorBox/investorReport'
import UtilEvent from '../utils/UtilEvent.js'
import investorCourt from './investorBox/investorCourt'
import investorTelMeeting from './investorBox/investorTelMeeting'
import investorFinReport from './investorBox/investorFinReport'
import investorAnalyst from './investorBox/investorAnalyst'
import investorBusinessFile from './investorBox/investorBusinessFile'
import investorContactUs from './investorBox/investorContactUs'
import investorQuestions from './investorBox/investorQuestions'
  export default {
    name: 'newsList',
    components:{UtilEvent,YearsTitleListView,investorReport,investorQuestions,investorCourt,investorTelMeeting,investorContactUs,investorFinReport,investorAnalyst,investorBusinessFile},
    props: {
      
    },
    created(){
        
    },
    data () {
      return {
        conditionNewsList:{total:0,perPage:1,yearList:[],list:[]},
        telMeetingList:{total:0,perPage:1,yearList:[],list:[]},
        finYearsReportList:{total:0,perPage:1,yearList:[],list:[]},
        businessFileList:{total:0,perPage:1,yearList:[],list:[]},
        oldScrollTop:0,
        isShowTopTitle:true,
        showSecondTitle:false,
        lockSecondTop:false,
        topDivHeight:0,
        selectedSecond:'公告及新闻稿'
      }
    },
    computed:{
      
    },
    methods:{
      gotoBody(){
        this.$refs.parentDiv.scrollIntoView({
            behavior: "smooth",  // 平滑过渡
        });
      },
      scrolling(){
        //获取dom滚动距离
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
                    document.body.scrollTop;
        if(scrollTop >= this.topDivHeight){
          this.lockSecondTop = true;
        }else{
          this.lockSecondTop = false;
        }
        let scrollStep = scrollTop - this.oldScrollTop;
        this.oldScrollTop = scrollTop;
        if(!this.lockSecondTop){
          //scrollTop <= this.topDivHeight - 64 此距离是为了避免点击页签时候页面向上时候会把第一个导航漏出来
          if (scrollStep < 0 && (scrollTop <= this.topDivHeight - 64)) {
              this.isShowTopTitle = true;
          } else {
            if(scrollStep > 10){
                this.isShowTopTitle = false;
            }
          }
        }else{
          this.isShowTopTitle = false;
        }
        
      },
      clickSecondHandler(name){
        if(name != 'Investor Relations'){
          this.selectedSecond = name;
        }
        
        if(name == 'Investor Relations'){
          window.open('https://ir.kingsoft.com/','_blank')
        }
        this.$refs.secondNav.scrollIntoView({
            behavior: "smooth",  // 平滑过渡
        });
      }
      
    },
    watch:{
      
    },
    mounted(){
      //获得头部div高度
      this.topDivHeight = this.$refs.topDiv.offsetHeight;
      //刚加载页面后会有偏移量，便宜后再去监听
      setTimeout(()=>{
        window.addEventListener("scroll", this.scrolling)
      },300)
        
      
      //获取新闻及公告
      new UtilEvent().getAnnoListData(this);
      //获得电话会议
      new UtilEvent().getTelMeetingListData(this);
      //获得财务报告--年度报告
      new UtilEvent().getFinYearsReportListData(this)
      //获得企业管理文件
      new UtilEvent().getBusinessFileListData(this)
    },
    destroyed() {
      window.removeEventListener("scroll", this.scrolling);
    },
  }
  </script>

